import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useUpdateNotOnSiteReasonMutation } from "app/api/orders";
import { CustomerApproval, MAX_COMMENT_LENGTH } from "models/Order";
import { useState } from "react";
import { toast } from "react-toastify";

type EditReasonDialogProps = {
  onClose: () => void;
  approval: CustomerApproval;
};

const EditReasonDialog: React.FC<EditReasonDialogProps> = (props) => {
  const { onClose, approval } = props;
  const [reason, setReason] = useState(approval.notOnSiteDescription || "");
  const [updateNotOnSiteReason, { isLoading }] = useUpdateNotOnSiteReasonMutation();

  const handleSaveEdit = () => {
    updateNotOnSiteReason({
      orderId: approval.orderId,
      approvalId: approval.id,
      reason,
    })
      .unwrap()
      .then(() => {
        toast.success("Kommentar uppdaterad");
        onClose();
      })
      .catch(() => {
        toast.error("Något gick fel när kommentaren skulle uppdateras");
      });
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>Redigera kommentar</DialogTitle>

      <DialogContent dividers>
        <TextField
          type="text"
          variant="filled"
          label="Kommentar"
          autoFocus
          fullWidth
          multiline
          rows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />

        <Typography
          fontSize="small"
          color={reason.length < MAX_COMMENT_LENGTH ? "textSecondary" : "error"}
          textAlign="right"
          mt={1}
        >
          {reason.length} / {MAX_COMMENT_LENGTH} tecken
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" disabled={isLoading} onClick={onClose}>
          Avbryt
        </Button>
        <Button variant="contained" loading={isLoading} onClick={handleSaveEdit}>
          Spara
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditReasonDialog;
